import { useState } from 'react';
import { createReport, ReportInput } from '../api/reportApi';
import './ReportButton.css';

type Props = {
    targetType: ReportInput['targetType'];
    targetId: number;
    submitReport?: (report: ReportInput) => Promise<void>;
};

const ReportButton = ({ targetType, targetId, submitReport = createReport }: Props) => {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState<ReportInput['reason'] | ''>('');
    const [detail, setDetail] = useState('');
    const [status, setStatus] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const submit = async () => {
        if(!reason) { setStatus('신고 사유를 선택해 주세요.'); return; }
        setSubmitting(true);
        setStatus('');
        try {
            await submitReport({ targetType, targetId, reason, detail: detail.trim() });
            setStatus('신고가 접수되었습니다. 관리자가 확인하겠습니다.');
            setOpen(false);
        } catch (error: any) {
            setStatus(error?.response?.status === 409 ? '이미 신고한 내용입니다.' : '신고를 접수하지 못했습니다. 다시 시도해 주세요.');
        } finally {
            setSubmitting(false);
        }
    };

    return <div className="report-control">
        <button type="button" className="report-trigger" onClick={() => { setOpen(true); setStatus(''); }}>신고</button>
        {!open && status && <span className="report-status" role="status">{status}</span>}
        {open && <div className="report-backdrop" onMouseDown={(event) => { if(event.target === event.currentTarget) setOpen(false); }}>
            <div className="report-dialog" role="dialog" aria-modal="true" aria-label="콘텐츠 신고">
                <div className="report-dialog-heading"><div><span>COMMUNITY CARE</span><h2>콘텐츠 신고</h2></div><button type="button" onClick={() => setOpen(false)} aria-label="신고 창 닫기">×</button></div>
                {!localStorage.getItem('token') ? <p>신고하려면 로그인이 필요합니다. <a href="#/login">로그인하기 ↗</a></p> : <>
                    <p>불편한 내용을 알려주시면 운영자가 확인합니다.</p>
                    <label>신고 사유<select value={reason} onChange={(event) => setReason(event.target.value as ReportInput['reason'])}><option value="">선택해 주세요</option><option value="SPAM">광고·도배</option><option value="ABUSE">욕설·괴롭힘</option><option value="FALSE_INFORMATION">허위 정보</option><option value="OTHER">기타</option></select></label>
                    <label>상세 내용 <span>(선택)</span><textarea maxLength={1000} value={detail} onChange={(event) => setDetail(event.target.value)} placeholder="문제가 되는 부분을 알려주세요" /></label>
                    {status && <p className="report-error" role="alert">{status}</p>}
                    <button type="button" className="report-submit" disabled={submitting} onClick={submit}>{submitting ? '접수 중...' : '신고 접수'}</button>
                </>}
            </div>
        </div>}
    </div>;
};

export default ReportButton;
